<nz-ribbon class="ribbon" [nzText]="getResumeSourceName()" [nzColor]="getResumeSourceColor()">
  <div class="vertical basic-card resume-body">
    <!-- <nz-tag class="call-count" [nzColor]="'purple'" [nzBordered]="false">Call Count: 10</nz-tag> -->
    @if (resume) {
      <div class="horizontal-large">
        <div class="portrait-container">
          <img class="portrait" [src]="resume.subData.content?.portraitImageUrl" />
        </div>
        <div class="vertical no-gap">
          <div class="name">{{ resume.subData.content?.firstName }} {{ resume.subData.content?.lastName }}</div>
          <div class="position">
            {{ resume.subData.content?.mostRecentPosition }} &#64; {{ resume.subData.content?.mostRecentCompany }}
          </div>
        </div>
      </div>
      <div class="horizontal align-top">
        <div class="profile-sub-title">Voice</div>
        <div>{{ getDeepgramVoiceById()?.accent }} {{ getDeepgramVoiceById()?.gender }}</div>
      </div>

      <div class="horizontal align-top">
        <div class="profile-sub-title">Personality</div>
        <div class="horizontal wrap">
          @for (personality of selectedPersonalityList(); track $index) {
            <nz-tag [nzBordered]="false" [nzColor]="personality?.unsafeSubData?.color">{{ personality?.title }}</nz-tag>
          }
        </div>
      </div>

      <app-edit-resume [resume]="resume" [(isVisible)]="isEditResumeVisible" [isEdit]="true"></app-edit-resume>
    }
  </div>

  <!-- <div class="delete-button horizontal">
          <button nz-button nzType="primary" [nzDanger]="true" nzSize="default" (click)="onDeleteProfileClick($event)">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
            Delete
          </button>
        </div> -->
</nz-ribbon>

<div class="vertical edit-button">
  <button nz-button nzType="primary" nzSize="default" [nzDanger]="false" (click)="onViewDetailsClick($event)">
    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">pageview</span>
    View Summary
  </button>

  <button nz-button nzType="default" nzSize="default" [nzDanger]="false" (click)="onEditProfileClick($event)">
    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">edit</span>
    Edit
  </button>

  <button nz-button nzType="default" nzSize="default" [nzDanger]="false" (click)="onCopyProfileClick($event)">
    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">content_copy</span>
    Duplicate
  </button>
</div>

<app-view-resume-details
  [resume]="showDetailsResume!"
  [(isVisible)]="isViewResumeDetailsVisible"
  (isVisibleChange)="onViewResumeDetailsVisibleChange($event)"
></app-view-resume-details>
